import { Tooltip } from '@/ui/Tooltip'
import { useOffline } from '../hooks/useOffline'

import styles from './OfflineLabel.module.scss'

import OfflineIcon from '../assets/offline.svg'

export const OfflineLabel = () => {
    const isOffline = useOffline()

    if (!isOffline) {
        return null
    }

    return (
        <Tooltip
            className={styles.tooltipContainer}
            tooltip={<div className={styles.tooltip}>Changes will be synced when you get online</div>}
            placement="bottom"
        >
            <div className={styles.container}>
                <OfflineIcon />
                <span className={styles.label}>Offline</span>
            </div>
        </Tooltip>
    )
}
